import { defineNuxtRouteMiddleware } from "#imports";
import { useHttpFromRoute } from "./composables/useHttpFromRoute.js";
import { useLogger } from "./composables/useLogger.js";
export default defineNuxtRouteMiddleware((route) => {
  const httpData = useHttpFromRoute(route);
  const { owners, ...http } = httpData;
  useLogger().appendGlobalContext({
    ...owners.length > 0 ? { owners } : {},
    http
  });
});
